import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN } from '../constants';
import { isSentryEnabled } from '../services/sentry';

export const initializeSentryClient = (env_name: string): void => {
	if (Sentry.isInitialized()) {
		return;
	}
	const isProd = env_name === 'production' || env_name === 'prod';
	Sentry.init({
		dsn: SENTRY_DSN,
		integrations: [Sentry.replayIntegration(), Sentry.browserProfilingIntegration()],
		tracesSampleRate: isProd ? 0.1 : 1.0,
		profilesSampleRate: isProd ? 0.1 : 1.0,
		replaysSessionSampleRate: isProd ? 0.1 : 1.0,
		replaysOnErrorSampleRate: isProd ? 0.1 : 1.0,
		debug: !isProd,
		environment: env_name,
		beforeSend(event) {
			if (!isSentryEnabled()) {
				return null;
			}
			return event;
		},
	});
};
